/** Shared market context for DIP / LONG_TERM lanes (independent of Market Tide). */

function sma(closes, period) {
  if (!closes?.length || closes.length < period) return null;
  const slice = closes.slice(0, period);
  return slice.reduce((s, v) => s + v, 0) / period;
}

/** Stock close[0] above its own 20-day SMA. */
export function isAboveSma20(closes) {
  const s = sma(closes, 20);
  if (s == null || closes[0] == null) return false;
  return closes[0] > s;
}

/**
 * @param {{ spyCloses?: number[], breadthPct20?: number|null }} input
 */
export function buildMarketContext(input = {}) {
  const spyCloses = input.spyCloses;
  const ctx = {
    spyAbove200: false,
    spyDrawdown20: null,
    spyDrawdown52w: null,
    breadthPct20: input.breadthPct20 ?? null,
    spyCloses: spyCloses ?? null,
  };
  if (!spyCloses?.length) return ctx;

  const price = spyCloses[0];
  const sma200 = sma(spyCloses, 200);
  ctx.spyAbove200 = sma200 != null && price > sma200;

  const high20 = Math.max(...spyCloses.slice(0, Math.min(20, spyCloses.length)));
  if (high20 > 0) ctx.spyDrawdown20 = ((high20 - price) / high20) * 100;

  const yr = spyCloses.slice(0, Math.min(252, spyCloses.length));
  const high52 = Math.max(...yr);
  if (high52 > 0) ctx.spyDrawdown52w = ((high52 - price) / high52) * 100;

  return ctx;
}

export function computeBreadthPct20(symbolClosesList) {
  if (!symbolClosesList?.length) return null;
  let above = 0;
  let n = 0;
  for (const closes of symbolClosesList) {
    if (!closes?.length || closes.length < 21) continue;
    n += 1;
    if (isAboveSma20(closes)) above += 1;
  }
  if (n === 0) return null;
  return (above / n) * 100;
}

export function marketContextBanners(marketCtx) {
  const banners = [];
  if (marketCtx?.breadthPct20 != null && marketCtx.breadthPct20 < 15) {
    banners.push({
      id: "washout",
      text: "Market washout — historically near short-term lows. Dip lane active.",
    });
  }
  if (marketCtx?.spyDrawdown52w != null && marketCtx.spyDrawdown52w >= 10) {
    banners.push({
      id: "lt_drawdown",
      text: "Long-term accumulation window — market drawdown.",
    });
  }
  return banners;
}
